export const ITEMS_PER_PAGE_LIST = [10, 25, 50, 100, 500];
export const DEFAULT_ITEMS_PER_PAGE = 25;
export const PAGE_PARAM_NAME = 'page';
export const LIMIT_PARAM_NAME = 'limit';
export const START_PAGE = '1';
